/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import AqaCellColours from '../model/AqaCellColours';
import AqaDistribution from '../model/AqaDistribution';
import AqaHeatmap from '../model/AqaHeatmap';
import AqaResponse from '../model/AqaResponse';
import AqaScore from '../model/AqaScore';
import AqaSheetChoice from '../model/AqaSheetChoice';
import AqaSheetSelection from '../model/AqaSheetSelection';
import AqaSnapshot from '../model/AqaSnapshot';
import AqaSnapshotFilter from '../model/AqaSnapshotFilter';
import AqaSnapshotResponse from '../model/AqaSnapshotResponse';
import AqaSubsnapshotCreationResponse from '../model/AqaSubsnapshotCreationResponse';
import AqaTable from '../model/AqaTable';
import AqaVector from '../model/AqaVector';
import AqaVectorColours from '../model/AqaVectorColours';
import AqaVectorQualityDefinition from '../model/AqaVectorQualityDefinition';
import AqaVectorValues from '../model/AqaVectorValues';
import CharsetForSnapshotRequest from '../model/CharsetForSnapshotRequest';
import SimplifiedVectorSummary from '../model/SimplifiedVectorSummary';
import StreamingResponseBody from '../model/StreamingResponseBody';
import UploadMonitor from '../model/UploadMonitor';

/**
* AQASnapshotController service.
* @module api/AQASnapshotControllerApi
* @version v0
*/
export default class AQASnapshotControllerApi {

    /**
    * Constructs a new AQASnapshotControllerApi. 
    * @alias module:api/AQASnapshotControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the del operation.
     * @callback moduleapi/AQASnapshotControllerApi~delCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes a snapshot
     * @param {String} id 
     * @param {module:api/AQASnapshotControllerApi~delCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    del(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling del");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the downloadSnapshot operation.
     * @callback moduleapi/AQASnapshotControllerApi~downloadSnapshotCallback
     * @param {String} error Error message, if any.
     * @param {'Blob'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Download a snapshot as its original file
     * @param {String} id 
     * @param {module:api/AQASnapshotControllerApi~downloadSnapshotCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    downloadSnapshot(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling downloadSnapshot");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = 'Blob';

      return this.apiClient.callApi(
        '/api/v1/snapshots/{id}/original', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the filterSnapshot operation.
     * @callback moduleapi/AQASnapshotControllerApi~filterSnapshotCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaSubsnapshotCreationResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Filters a snapshot into a different snapshot, from a provided list of elementary filters.
     * @param {Array.<module:model/AqaSnapshotFilter>} body 
     * @param {String} id 
     * @param {module:api/AQASnapshotControllerApi~filterSnapshotCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    filterSnapshot(body, id, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling filterSnapshot");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling filterSnapshot");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaSubsnapshotCreationResponse;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{id}/subsnapshot', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getAll operation.
     * @callback moduleapi/AQASnapshotControllerApi~getAllCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaSnapshot>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This retrieves all the existing snapshots
     * @param {module:api/AQASnapshotControllerApi~getAllCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAll(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaSnapshot];

      return this.apiClient.callApi(
        '/api/v1/snapshots/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getColVector operation.
     * @callback moduleapi/AQASnapshotControllerApi~getColVectorCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaVector{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a column summary
     * @param {String} snapshotId 
     * @param {String} colId 
     * @param {module:api/AQASnapshotControllerApi~getColVectorCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getColVector(snapshotId, colId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getColVector");
      }
      // verify the required parameter 'colId' is set
      if (colId === undefined || colId === null) {
        throw new Error("Missing the required parameter 'colId' when calling getColVector");
      }

      let pathParams = {
        'snapshotId': snapshotId,'colId': colId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaVector;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/columns/{colId}/simplification', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getColVectorDistribution operation.
     * @callback moduleapi/AQASnapshotControllerApi~getColVectorDistributionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaDistribution{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the distributions for this column
     * @param {String} snapshotId 
     * @param {String} colId 
     * @param {String} type 
     * @param {String} nBars 
     * @param {module:api/AQASnapshotControllerApi~getColVectorDistributionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getColVectorDistribution(snapshotId, colId, type, nBars, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getColVectorDistribution");
      }
      // verify the required parameter 'colId' is set
      if (colId === undefined || colId === null) {
        throw new Error("Missing the required parameter 'colId' when calling getColVectorDistribution");
      }
      // verify the required parameter 'type' is set
      if (type === undefined || type === null) {
        throw new Error("Missing the required parameter 'type' when calling getColVectorDistribution");
      }
      // verify the required parameter 'nBars' is set
      if (nBars === undefined || nBars === null) {
        throw new Error("Missing the required parameter 'nBars' when calling getColVectorDistribution");
      }

      let pathParams = {
        'snapshotId': snapshotId,'colId': colId
      };
      let queryParams = {
        'type': type,'nBars': nBars
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaDistribution;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/columns/{colId}/distribution', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getColVectorSimplified operation.
     * @callback moduleapi/AQASnapshotControllerApi~getColVectorSimplifiedCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SimplifiedVectorSummary{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a simplified column summary with extra statistics
     * @param {String} snapshotId 
     * @param {String} colId 
     * @param {module:api/AQASnapshotControllerApi~getColVectorSimplifiedCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getColVectorSimplified(snapshotId, colId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getColVectorSimplified");
      }
      // verify the required parameter 'colId' is set
      if (colId === undefined || colId === null) {
        throw new Error("Missing the required parameter 'colId' when calling getColVectorSimplified");
      }

      let pathParams = {
        'snapshotId': snapshotId,'colId': colId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = SimplifiedVectorSummary;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/columns/{colId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getColVectorValues operation.
     * @callback moduleapi/AQASnapshotControllerApi~getColVectorValuesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaVectorValues>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the values of this column. Offset and limit can be used to get a subset of the vectors values. quantity indicates how many columns you want, starting from rowid.
     * @param {String} snapshotId 
     * @param {Number} colId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset  (default to <.>)
     * @param {Number} opts.limit  (default to <.>)
     * @param {Number} opts.quantity  (default to <.>)
     * @param {module:api/AQASnapshotControllerApi~getColVectorValuesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getColVectorValues(snapshotId, colId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getColVectorValues");
      }
      // verify the required parameter 'colId' is set
      if (colId === undefined || colId === null) {
        throw new Error("Missing the required parameter 'colId' when calling getColVectorValues");
      }

      let pathParams = {
        'snapshotId': snapshotId,'colId': colId
      };
      let queryParams = {
        'offset': opts['offset'],'limit': opts['limit'],'quantity': opts['quantity']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaVectorValues];

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/columns/{colId}/values', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getColourAndOverrideMaps operation.
     * @callback moduleapi/AQASnapshotControllerApi~getColourAndOverrideMapsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StreamingResponseBody{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {module:api/AQASnapshotControllerApi~getColourAndOverrideMapsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getColourAndOverrideMaps(snapshotId, orientation, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getColourAndOverrideMaps");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling getColourAndOverrideMaps");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = 'Blob';

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/colourandoverridemaps/{orientation}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getColourmap operation.
     * @callback moduleapi/AQASnapshotControllerApi~getColourmapCallback
     * @param {String} error Error message, if any.
     * @param {'Blob'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the whole snapshot colours as a binary file
     * @param {String} snapshotId 
     * @param {module:api/AQASnapshotControllerApi~getColourmapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getColourmap(snapshotId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getColourmap");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/octet-stream'];
      let returnType = 'Blob';

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/colourmap', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getColumnVectorColours operation.
     * @callback moduleapi/AQASnapshotControllerApi~getColumnVectorColoursCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaVectorColours{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the column&#x27;s colours
     * @param {String} snapshotId 
     * @param {Number} colId 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withSpecifics  (default to <.>)
     * @param {module:api/AQASnapshotControllerApi~getColumnVectorColoursCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getColumnVectorColours(snapshotId, colId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getColumnVectorColours");
      }
      // verify the required parameter 'colId' is set
      if (colId === undefined || colId === null) {
        throw new Error("Missing the required parameter 'colId' when calling getColumnVectorColours");
      }

      let pathParams = {
        'snapshotId': snapshotId,'colId': colId
      };
      let queryParams = {
        'withSpecifics': opts['withSpecifics']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaVectorColours;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/columns/{colId}/colours', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getColumnVectorColoursForAllVectors operation.
     * @callback moduleapi/AQASnapshotControllerApi~getColumnVectorColoursForAllVectorsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaVectorColours>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns colours for all vectors
     * @param {String} snapshotId 
     * @param {module:api/AQASnapshotControllerApi~getColumnVectorColoursForAllVectorsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getColumnVectorColoursForAllVectors(snapshotId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getColumnVectorColoursForAllVectors");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaVectorColours];

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/columns/colours/all', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getHeatImage operation.
     * @callback moduleapi/AQASnapshotControllerApi~getHeatImageCallback
     * @param {String} error Error message, if any.
     * @param {'Blob'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a column-scale heat map for the snapshot
     * @param {String} snapshotId 
     * @param {module:api/AQASnapshotControllerApi~getHeatImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getHeatImage(snapshotId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getHeatImage");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['image/png'];
      let returnType = 'Blob';

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/heat', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getNarrowColourmap operation.
     * @callback moduleapi/AQASnapshotControllerApi~getNarrowColourmapCallback
     * @param {String} error Error message, if any.
     * @param {'Blob'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the whole snapshot colours as a binary file
     * @param {String} snapshotId 
     * @param {module:api/AQASnapshotControllerApi~getNarrowColourmapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getNarrowColourmap(snapshotId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getNarrowColourmap");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/octet-stream'];
      let returnType = 'Blob';

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/narrowcolourmap', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getQualityFromSnapshot operation.
     * @callback moduleapi/AQASnapshotControllerApi~getQualityFromSnapshotCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaVectorQualityDefinition{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This retrieves a AqaVectorQualityDefinition object for a given snapshot, an orientation, and vector index
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {Number} vectorId 
     * @param {module:api/AQASnapshotControllerApi~getQualityFromSnapshotCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getQualityFromSnapshot(snapshotId, orientation, vectorId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getQualityFromSnapshot");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling getQualityFromSnapshot");
      }
      // verify the required parameter 'vectorId' is set
      if (vectorId === undefined || vectorId === null) {
        throw new Error("Missing the required parameter 'vectorId' when calling getQualityFromSnapshot");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation,'vectorId': vectorId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaVectorQualityDefinition;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/{orientation}/{vectorId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getRowVector operation.
     * @callback moduleapi/AQASnapshotControllerApi~getRowVectorCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaVector{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a row summary
     * @param {String} snapshotId 
     * @param {String} rowId 
     * @param {module:api/AQASnapshotControllerApi~getRowVectorCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getRowVector(snapshotId, rowId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getRowVector");
      }
      // verify the required parameter 'rowId' is set
      if (rowId === undefined || rowId === null) {
        throw new Error("Missing the required parameter 'rowId' when calling getRowVector");
      }

      let pathParams = {
        'snapshotId': snapshotId,'rowId': rowId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaVector;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/rows/{rowId}/simplification', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getRowVectorColours operation.
     * @callback moduleapi/AQASnapshotControllerApi~getRowVectorColoursCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaVectorColours{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the row&#x27;s colours
     * @param {String} snapshotId 
     * @param {Number} rowId 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withSpecifics  (default to <.>)
     * @param {module:api/AQASnapshotControllerApi~getRowVectorColoursCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getRowVectorColours(snapshotId, rowId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getRowVectorColours");
      }
      // verify the required parameter 'rowId' is set
      if (rowId === undefined || rowId === null) {
        throw new Error("Missing the required parameter 'rowId' when calling getRowVectorColours");
      }

      let pathParams = {
        'snapshotId': snapshotId,'rowId': rowId
      };
      let queryParams = {
        'withSpecifics': opts['withSpecifics']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaVectorColours;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/rows/{rowId}/colours', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getRowVectorColoursAcrossColumns operation.
     * @callback moduleapi/AQASnapshotControllerApi~getRowVectorColoursAcrossColumnsCallback
     * @param {String} error Error message, if any.
     * @param {Object.<String, {'String': 'Number'}>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a row&#x27;s colours based on column VQDs
     * @param {String} snapshotId 
     * @param {Number} rowId 
     * @param {module:api/AQASnapshotControllerApi~getRowVectorColoursAcrossColumnsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getRowVectorColoursAcrossColumns(snapshotId, rowId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getRowVectorColoursAcrossColumns");
      }
      // verify the required parameter 'rowId' is set
      if (rowId === undefined || rowId === null) {
        throw new Error("Missing the required parameter 'rowId' when calling getRowVectorColoursAcrossColumns");
      }

      let pathParams = {
        'snapshotId': snapshotId,'rowId': rowId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = {'String': 'Number'};

      return this.apiClient.callApi(
        '/api/v1/snapshots/colours/{snapshotId}/rows/{rowId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getRowVectorColoursAcrossColumnsAsJson operation.
     * @callback moduleapi/AQASnapshotControllerApi~getRowVectorColoursAcrossColumnsAsJsonCallback
     * @param {String} error Error message, if any.
     * @param {Object.<String, module:model/{'String': AqaCellColours}>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a row&#x27;s colours based on column VQDs
     * @param {String} snapshotId 
     * @param {Number} rowId 
     * @param {module:api/AQASnapshotControllerApi~getRowVectorColoursAcrossColumnsAsJsonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getRowVectorColoursAcrossColumnsAsJson(snapshotId, rowId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getRowVectorColoursAcrossColumnsAsJson");
      }
      // verify the required parameter 'rowId' is set
      if (rowId === undefined || rowId === null) {
        throw new Error("Missing the required parameter 'rowId' when calling getRowVectorColoursAcrossColumnsAsJson");
      }

      let pathParams = {
        'snapshotId': snapshotId,'rowId': rowId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = {'String': AqaCellColours};

      return this.apiClient.callApi(
        '/api/v1/snapshots/colours/json/{snapshotId}/rows/{rowId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getRowVectorDistribution operation.
     * @callback moduleapi/AQASnapshotControllerApi~getRowVectorDistributionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaDistribution{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the distributions for this row
     * @param {String} snapshotId 
     * @param {String} rowId 
     * @param {String} type 
     * @param {String} nBars 
     * @param {module:api/AQASnapshotControllerApi~getRowVectorDistributionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getRowVectorDistribution(snapshotId, rowId, type, nBars, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getRowVectorDistribution");
      }
      // verify the required parameter 'rowId' is set
      if (rowId === undefined || rowId === null) {
        throw new Error("Missing the required parameter 'rowId' when calling getRowVectorDistribution");
      }
      // verify the required parameter 'type' is set
      if (type === undefined || type === null) {
        throw new Error("Missing the required parameter 'type' when calling getRowVectorDistribution");
      }
      // verify the required parameter 'nBars' is set
      if (nBars === undefined || nBars === null) {
        throw new Error("Missing the required parameter 'nBars' when calling getRowVectorDistribution");
      }

      let pathParams = {
        'snapshotId': snapshotId,'rowId': rowId
      };
      let queryParams = {
        'type': type,'nBars': nBars
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaDistribution;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/rows/{rowId}/distribution', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getRowVectorSimplified operation.
     * @callback moduleapi/AQASnapshotControllerApi~getRowVectorSimplifiedCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SimplifiedVectorSummary{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a simplified row summary with extra statistics
     * @param {String} snapshotId 
     * @param {String} rowId 
     * @param {module:api/AQASnapshotControllerApi~getRowVectorSimplifiedCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getRowVectorSimplified(snapshotId, rowId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getRowVectorSimplified");
      }
      // verify the required parameter 'rowId' is set
      if (rowId === undefined || rowId === null) {
        throw new Error("Missing the required parameter 'rowId' when calling getRowVectorSimplified");
      }

      let pathParams = {
        'snapshotId': snapshotId,'rowId': rowId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = SimplifiedVectorSummary;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/rows/{rowId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getRowVectorValues operation.
     * @callback moduleapi/AQASnapshotControllerApi~getRowVectorValuesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaVectorValues>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the values of this row. Offset and limit can be used to get a subset of the vectors values. quantity indicates how many rows you want, starting from rowid.
     * @param {String} snapshotId 
     * @param {Number} rowId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset  (default to <.>)
     * @param {Number} opts.limit  (default to <.>)
     * @param {Number} opts.quantity  (default to <.>)
     * @param {String} opts.notes  (default to <.>)
     * @param {module:api/AQASnapshotControllerApi~getRowVectorValuesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getRowVectorValues(snapshotId, rowId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getRowVectorValues");
      }
      // verify the required parameter 'rowId' is set
      if (rowId === undefined || rowId === null) {
        throw new Error("Missing the required parameter 'rowId' when calling getRowVectorValues");
      }

      let pathParams = {
        'snapshotId': snapshotId,'rowId': rowId
      };
      let queryParams = {
        'offset': opts['offset'],'limit': opts['limit'],'quantity': opts['quantity'],'notes': opts['notes']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaVectorValues];

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/rows/{rowId}/values', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSheets operation.
     * @callback moduleapi/AQASnapshotControllerApi~getSheetsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaSheetChoice{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a list of sheets for a snapshot - only use after an upload
     * @param {String} snapshotId 
     * @param {module:api/AQASnapshotControllerApi~getSheetsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSheets(snapshotId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getSheets");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaSheetChoice;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/sheets', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSnapshot operation.
     * @callback moduleapi/AQASnapshotControllerApi~getSnapshotCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaSnapshot{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a snapshot
     * @param {String} id 
     * @param {module:api/AQASnapshotControllerApi~getSnapshotCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSnapshot(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSnapshot");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaSnapshot;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSnapshotColumnsHeatmap operation.
     * @callback moduleapi/AQASnapshotControllerApi~getSnapshotColumnsHeatmapCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaHeatmap{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the columns-based heatmap for this snapshot
     * @param {String} snapshotId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.width  (default to <.>)
     * @param {Number} opts.height  (default to <.>)
     * @param {String} opts.recompute  (default to <.>)
     * @param {Number} opts.columnIndex  (default to <.>)
     * @param {module:api/AQASnapshotControllerApi~getSnapshotColumnsHeatmapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSnapshotColumnsHeatmap(snapshotId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getSnapshotColumnsHeatmap");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        'width': opts['width'],'height': opts['height'],'recompute': opts['recompute'],'columnIndex': opts['columnIndex']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaHeatmap;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/columnsheatmap', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSnapshotRowsHeatmap operation.
     * @callback moduleapi/AQASnapshotControllerApi~getSnapshotRowsHeatmapCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaHeatmap{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the rows-based heatmap for this snapshot
     * @param {String} snapshotId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.width  (default to <.>)
     * @param {Number} opts.height  (default to <.>)
     * @param {String} opts.recompute  (default to <.>)
     * @param {Number} opts.rowIndex  (default to <.>)
     * @param {module:api/AQASnapshotControllerApi~getSnapshotRowsHeatmapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSnapshotRowsHeatmap(snapshotId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getSnapshotRowsHeatmap");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        'width': opts['width'],'height': opts['height'],'recompute': opts['recompute'],'rowIndex': opts['rowIndex']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaHeatmap;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/rowsheatmap', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSnapshotScore operation.
     * @callback moduleapi/AQASnapshotControllerApi~getSnapshotScoreCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaScore{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the score for this snapshot
     * @param {String} snapshotId 
     * @param {module:api/AQASnapshotControllerApi~getSnapshotScoreCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSnapshotScore(snapshotId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getSnapshotScore");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaScore;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/score', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSnapshotStatus operation.
     * @callback moduleapi/AQASnapshotControllerApi~getSnapshotStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UploadMonitor{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Snapshot upload status
     * @param {String} id 
     * @param {module:api/AQASnapshotControllerApi~getSnapshotStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSnapshotStatus(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSnapshotStatus");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = UploadMonitor;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{id}/status', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getTable operation.
     * @callback moduleapi/AQASnapshotControllerApi~getTableCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaTable{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a table summary
     * @param {String} snapshotId 
     * @param {module:api/AQASnapshotControllerApi~getTableCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getTable(snapshotId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getTable");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaTable;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/table', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getTypesMap operation.
     * @callback moduleapi/AQASnapshotControllerApi~getTypesMapCallback
     * @param {String} error Error message, if any.
     * @param {'String'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a text map of the table&#x27;s types
     * @param {String} snapshotid 
     * @param {module:api/AQASnapshotControllerApi~getTypesMapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getTypesMap(snapshotid, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotid' is set
      if (snapshotid === undefined || snapshotid === null) {
        throw new Error("Missing the required parameter 'snapshotid' when calling getTypesMap");
      }

      let pathParams = {
        'snapshotid': snapshotid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['text/plain;charset=UTF-8', 'text/plain; charset=UTF-8'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotid}/types', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the selectSheet operation.
     * @callback moduleapi/AQASnapshotControllerApi~selectSheetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaSnapshotResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Sets the sheet to use in a snapshot and launches the analysis
     * @param {module:model/AqaSheetSelection} body 
     * @param {String} snapshotId 
     * @param {module:api/AQASnapshotControllerApi~selectSheetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    selectSheet(body, snapshotId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling selectSheet");
      }
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling selectSheet");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaSnapshotResponse;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotId}/sheets', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the setCharset operation.
     * @callback moduleapi/AQASnapshotControllerApi~setCharsetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Assigns a charset to a snapshot
     * @param {module:model/CharsetForSnapshotRequest} body 
     * @param {String} id 
     * @param {module:api/AQASnapshotControllerApi~setCharsetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    setCharset(body, id, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling setCharset");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setCharset");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{id}/charset', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateSnapshotStatusChange operation.
     * @callback moduleapi/AQASnapshotControllerApi~updateSnapshotStatusChangeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the status change in the snapshot
     * @param {String} snapshotid 
     * @param {String} status 
     * @param {module:api/AQASnapshotControllerApi~updateSnapshotStatusChangeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateSnapshotStatusChange(snapshotid, status, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotid' is set
      if (snapshotid === undefined || snapshotid === null) {
        throw new Error("Missing the required parameter 'snapshotid' when calling updateSnapshotStatusChange");
      }
      // verify the required parameter 'status' is set
      if (status === undefined || status === null) {
        throw new Error("Missing the required parameter 'status' when calling updateSnapshotStatusChange");
      }

      let pathParams = {
        'snapshotid': snapshotid
      };
      let queryParams = {
        'status': status
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/snapshots/{snapshotid}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the uploadAllColours operation.
     * @callback moduleapi/AQASnapshotControllerApi~uploadAllColoursCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Uploads Colours for all vectors - This creates a new snapshot whose id will be returned
     * @param {Array.<module:model/AqaVectorColours>} body 
     * @param {String} sourceId 
     * @param {module:api/AQASnapshotControllerApi~uploadAllColoursCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    uploadAllColours(body, sourceId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling uploadAllColours");
      }
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling uploadAllColours");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/snapshots/source/{sourceId}/columns/colours', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}